import Layout from '@/app/ui/layout/index.vue';
import { FlagsPermissionKulioner } from '@/feature-flags/flags-kulioner';
import KulionerList from '@/app/ui/views/kulioner/index.vue';
import KulionerDetail from '@/app/ui/views/kulioner/detail/index.vue';

export default [
  {
    path: "/kulioner",
    redirect: "/dashboard",
    component: Layout,
    name: "kulioner",
    meta: {
      icon: "support-pos-favourite",
      children: false,
      header: true,
      title: "Pesanan Kulioner",
      name: "Pesanan Kulioner",
      customName: "Daftar pesanan kulioner",
      permission: FlagsPermissionKulioner.permission_kulioner_enable,
    },
    children: [
      {
        path: "",
        name: "kulioner-list",
        component: KulionerList,
        meta: {
          header: true,
          isAuth: true
        }
      },
      {
        path: "detail/:id",
        name: "kulioner-detail",
        component: KulionerDetail,
        meta: {
          header: true,
          isAuth: true,
          persmision: FlagsPermissionKulioner.permission_kulioner_detail_view
        }
      },
    ]
  }
]

